import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache so we only hit the endpoint once per page load
let brandingPromise = null;

const fetchBranding = () => {
  if (!brandingPromise) {
    brandingPromise = axios
      .get(`${API}/public-settings`)
      .then((res) => res.data)
      .catch(() => ({ company_name: 'RetouchingPix', logo_url: null }));
  }
  return brandingPromise;
};

// Allow other parts of the app (e.g. settings save) to invalidate the cache
export const invalidateBrandingCache = () => {
  brandingPromise = null;
};

const BrandLogo = ({ className = 'h-12', alt }) => {
  const [branding, setBranding] = useState({ company_name: 'RetouchingPix', logo_url: null });

  useEffect(() => {
    let mounted = true;
    fetchBranding().then((data) => {
      if (mounted && data) setBranding(data);
    });
    return () => {
      mounted = false;
    };
  }, []);

  const src = branding.logo_url || '/logo.webp';
  const label = alt || branding.company_name || 'RetouchingPix';

  return (
    <img
      data-testid="brand-logo"
      src={src}
      alt={label}
      className={className}
    />
  );
};

export default BrandLogo;
